import { render, staticRenderFns } from "./studyApply.vue?vue&type=template&id=b72fffa6&scoped=true"
import script from "./studyApply.vue?vue&type=script&lang=js"
export * from "./studyApply.vue?vue&type=script&lang=js"
import style0 from "./studyApply.vue?vue&type=style&index=0&id=b72fffa6&prod&scoped=true&lang=css"
import style1 from "./studyApply.vue?vue&type=style&index=1&id=b72fffa6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b72fffa6",
  null
  
)

export default component.exports